export default __webpack_public_path__ + "static/media/power.55ad7d62.png";